<template>
    <v-btn icon text :color="btnColor" @click="$emit('changePaidStatus', idProforma)">
        <paid-icon :color="btnColor" />
    </v-btn>
</template>

<script>
import paidIcon from '@/assets/icons/paid.vue'

export default {
    components: {
        paidIcon
    },
    name: 'Incasat',
    props: {
        idProforma: String,
        paidStatus: String
    },
    computed: {
        btnColor() {
            if (this.paidStatus == 'incasata') {
                return '#22c55e'
            }
            if (this.paidStatus == 'platita') {
                return '#3b82f6'
            }
            return '#4b5563'
        }
    }
}
</script>